module.exports = __webpack_public_path__ + "static/media/temple.fb269cf6.png";